<template>
    <div class="tamanhoPopUp">             
            <ag-grid-vue
                ref="agGridTable"        
                :gridOptions="configuracaoGrid.gridOptions"
                class="ag-theme-material ag-grid-table ag-grid-altura"
                :columnDefs="configuracaoGrid.columnDefs"
                :defaultColDef="configuracaoGrid.defaultColDef"
                :rowData="dadosDaGrid"
                :headerHeight="25"
                :rowHeight="25"
                :suppressHorizontalScroll="true"
                rowSelection="single"
                :rowMultiSelectWithClick="true"
                colResizeDefault="shift"
                @grid-ready="onGridReady"
                @row-selected="onRowSelectedRegistro"    
                :animateRows="true"
                :floatingFilter="false"
                :pagination="false"
                :paginationAutoPageSize="true"
                :suppressPaginationPanel="true">
            </ag-grid-vue>             
    </div>
</template>

<script>
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"

const URL_SERVLET = "/rest/TanqueCombustivel/Listar";

export default {    
    components: {
        AgGridVue
    },    
    data() {
        return {
            configuracaoGrid: { 
                gridApi: null, gridColumnApi: null, gridOptions: {}, 
                defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
                columnDefs: [        
                    { headerName: 'NÚMERO', field: 'numero' },
                    { headerName: 'COMBUSTÍVEL', field: 'tipoCombustivel.nome' },               
                ]
            },
            dadosDaGrid: [], 
            itensSelecionados: []           
        }
    },    
    methods: {
        fetchLista() {      
            const params = new URLSearchParams();      
            params.append('pagina', - 1);
            
            axios.post(URL_SERVLET, params, {              
                    credentials: 'include',
                    responseEncoding: 'iso88591',
                    withCredentials: true } )
            .then((response) => {
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' })
                } else {
                    this.totalRegistros = response.data.Resultado.quantidade;
                    if (response.data.Resultado.quantidade > 1) {
                        this.dadosDaGrid = response.data.Resultado.lista.item;
                    } else if (response.data.Resultado.quantidade === 1) {
                        this.dadosDaGrid = [];
                        this.dadosDaGrid.push(response.data.Resultado.lista.item);
                    } else {
                        this.dadosDaGrid = [];
                    }
                }
            })
            .catch((error) => { 
                /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
            })    
                                
        },
        onRowSelectedRegistro() {                  
            this.itensSelecionados = null;
            this.itensSelecionados = [];
            let self_ = this;
            var selectedRows = this.configuracaoGrid.gridApi.getSelectedRows();
            selectedRows.forEach(function(selectedRow) {
                self_.itensSelecionados.push(selectedRow);
            });                
            this.$emit('selecionarTanqueCombustivel', this.itensSelecionados);            
        },
        onGridReady() {            
            this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;       
            this.configuracaoGrid.gridColumnApi = this.configuracaoGrid.gridOptions.columnApi;                    
            this.fetchLista();            
        },        
    }    
}
</script>

<style lang="scss" scoped>
  .ag-grid-altura {       
    height: 340px; 
  }

  .tamanhoPopUp {
    height: 370px;       
  }  
</style>